import React, { useState, useEffect } from 'react';
import Moment from 'react-moment';
import queryString from 'query-string';
import StripeCheckout from 'react-stripe-checkout';
import useCallApi from '../../hooks/useCallApi'
import callAPI from '../../helpers/callAPI'

import Loading from '../../component/UI/Loading/Loading'
import maxbountyLogoSquare from '../../assets/images/MaxBounty_Square.png';

export default function Stripe({location, showSystemMessage}) {
    
    let urlParams = queryString.parse(location.search)

    let { m = 0, p = 0, i = 0, t = 0 } = urlParams;

    const { data, dataLoaded } = useCallApi(
        `stripe?m=${m}&p=${p}&i=${i}&t=${t}`,
        'GET',
        {}, [], showSystemMessage
    );

    const [stripeStatus, setStripeStatus] = useState('');
    const [invoiceInfo, setInvoiceInfo] = useState({
        merchantId: 0,
        amount: 0,
        invoice: 0,
        time: 0,
        merchantInfo: {
            name: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipcode: ''
        }
    })

    useEffect(() => {
        if (dataLoaded && data.invoiceInfo){
            setInvoiceInfo({
                amount: data.invoiceInfo.amount,
                invoice: data.invoiceInfo.invoice,
                merchantId: data.invoiceInfo.merchantId,
                time: data.invoiceInfo.time,
                merchantInfo: {
                    name: data.merchantInfo.name,
                    address1: data.merchantInfo.address1,
                    address2: data.merchantInfo.address2,
                    city: data.merchantInfo.city,
                    state: data.merchantInfo.state,
                    zipcode: data.merchantInfo.zipcode
                }
            })
        }
    }, [data, dataLoaded])

    const onToken = async (token) => {       

        const appendedData = { ...token, mbData: {
            p: p,
            i: i,
            m: m,
            t: t
        }};

        // We must now send the token server side to create the charge

        let result = await callAPI(`stripe`, 'POST', appendedData)

        if (result.success){
            setStripeStatus(true)
        } else {
            setStripeStatus(false)
        }        
    }
    
    return (
        <React.Fragment>
            { dataLoaded ? 

                <React.Fragment>
                    <section className="mt-5 pt-1 mx-2 pb-0">
                        <div className="card mx-auto mb-5" style={{maxWidth: '30rem', marginTop: '100px'}}>
                            <div className="mx-auto text-center mb-3 position-relative" style={{maxWidth: '150px', zIndex: '99', marginTop: '-100px'}}><img src={maxbountyLogoSquare} className="rounded" style={{width: '100%'}} alt="MaxBounty" /></div>

                            {   data.success ?

                                     invoiceInfo.merchantId !== 0 && invoiceInfo.amount !== 0 && invoiceInfo.invoice !== 0 && invoiceInfo.time !== 0 ?    

                                        <div className="card-body">

                                            { stripeStatus === '' ?

                                                <React.Fragment>
                                                    <div className="d-flex justify-content-between text-secondary alert alert-secondary">
                                                        <div>Invoice #{invoiceInfo.invoice}</div>
                                                        <div><Moment  format="YYYY/MM/DD">{invoiceInfo.time}</Moment></div>
                                                    </div>
                                                    <table className="table table-striped mt-4">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">{invoiceInfo.merchantInfo.name}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <div>{invoiceInfo.merchantInfo.address1}</div>
                                                                    { invoiceInfo.merchantInfo.address2 && <div>{invoiceInfo.merchantInfo.address2}</div> }
                                                                    <div>{invoiceInfo.merchantInfo.city}, {invoiceInfo.merchantInfo.state}</div>
                                                                    <div>{invoiceInfo.merchantInfo.zipcode}</div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>                        
                                                    <div className="alert alert-success text-center mb-3">
                                                        <p>Amount Owing:</p>
                                                        <h2 className="font-weight-bold">${invoiceInfo.amount}</h2>
                                                    </div>
                                                    <div className="text-center">
                                                        <StripeCheckout
                                                            key={"MaxBounty"}
                                                            name="MaxBounty"
                                                            description="Advertiser Payment"
                                                            token={onToken}
                                                            stripeKey={process.env.REACT_APP_STRIPE_KEY}
                                                            billingAddress={true}
                                                            image={maxbountyLogoSquare}
                                                            amount={invoiceInfo.amount*100} // Stripe uses cents
                                                            allowRememberMe={true}
                                                        />
                                                    </div>
                                                </React.Fragment>

                                            : stripeStatus === true ?

                                                <div className="alert alert-success m-2">Your payment has been processed. You will receive an e-mail receipt shortly.</div>

                                            :

                                                <div className="alert alert-danger m-2">There was a problem submitting your request. Please refresh the page and try again.</div>

                                            }

                                        </div>
                                    :

                                        <div className="alert alert-danger m-2">Invalid Invoice. Please check the link we provided you again.</div>

                                    
                                :
                                
                                    <div className="alert alert-danger m-2">Invalid Invoice. Please check the link we provided you again.</div>

                            }                                
                            
                        </div>

                        <hr></hr>                       
                        
                    </section>

                    
                </React.Fragment>

            :

                <div style={{marginTop: "100px"}}><Loading /></div>

            }
        </React.Fragment>
   )        

}
